export class SalesDetailsModel {

    public leadQualityId: number;
    public leadStatusId: number;
    public potentionalInvestmentId: number;
    public lastContact: string;
    public pipelineAmount: string;
    public pipelineDate: string;
    public note: string;
    public noteUpdatedBy: string;

    constructor(obj?: any) {
        this.leadQualityId              = obj && obj.leadQualityId              || null;
        this.leadStatusId               = obj && obj.leadStatusId               || null;
        this.potentionalInvestmentId    = obj && obj.potentionalInvestmentId    || null;
        this.lastContact                = obj && obj.lastContact                || '';
        this.pipelineAmount             = obj && obj.pipelineAmount             || '';
        this.pipelineDate               = obj && obj.pipelineDate               || '';
        this.note                       = obj && obj.note                       || '';
        this.noteUpdatedBy              = obj && obj.noteUpdatedBy              || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/sales-details.model.ts